import Card from 'react-bootstrap/Card';
import logofoot from '../assets/Images/logo-foot.png';
import React from 'react';
import { useState } from "react";

function HomeCard(props) {
  const [desc, setDesc] = useState(false);
  function appearContent() {
    setDesc(!desc);
  }
  const cardClassName = desc ? 'rounded-4 cardBackground shadow-lg' : 'rounded-4 cardBackground shadow-lg';
  // const cardNameClassName = props.CardName ? `card-name-${props.CardName.toLowerCase().replace(/\s/g, '-')}` : '';

  const combinedClassName = `${cardClassName}   ${props.className}`;


  return (

    <Card onMouseEnter={appearContent} style={{
      color: '#FBF3E4', width: '18rem',
      height: '30rem', // Set initial height to 10rem
    }} className={combinedClassName} >


    </Card>
  );
}

export default HomeCard;